// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecureChatBadge__secure-d4ffc4 {
  fill: var(--base-110);
  min-width: 16px;
  margin-inline-end: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/SecureChatBadge/SecureChatBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;AACF","sourcesContent":[".secure {\n  fill: var(--base-110);\n  min-width: 16px;\n  margin-inline-end: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secure": `SecureChatBadge__secure-d4ffc4`
};
module.exports = ___CSS_LOADER_EXPORT___;
